import { render, staticRenderFns } from "./TeamInboxAuthRedirect.vue?vue&type=template&id=006d2fb5&scoped=true"
import script from "./TeamInboxAuthRedirect.vue?vue&type=script&lang=js"
export * from "./TeamInboxAuthRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006d2fb5",
  null
  
)

export default component.exports